module.exports = __webpack_public_path__ + "media/img/frontend_application/stripe-gray-img-6bfe2abea9d64d3e6f097d477d0bebc3.svg";